import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { TrackingScreen } from '../../app/utils/tracking';
import { categoryToSubscreenMap } from '../../app/utils/tracking/utils';
import { FeedbackBtnClickTrackerContext, MeetingScheduleLinkClickTrackerContext } from '../contexts/Tracking';
import { isEnrolled } from './utils/enrollmentStatus';
import FeedbackButton from './FeedbackButton';
import JoinEnrollmentButton from './EnrollmentButtons/JoinEnrollmentButton';
import RequestToJoinEnrollmentButton from './EnrollmentButtons/RequestToJoinEnrollmentButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProductUpdatesBetaButton = ({
  productUpdate,
  category
}) => {
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  const {
    id: productUpdateId,
    rollout: {
      enrollType,
      enrollmentStatus,
      gate,
      id: rolloutId,
      betaPaused: isBetaClosed
    },
    rolloutState,
    title,
    untranslatedTitle,
    userFeedbackSubmissionInfo
  } = productUpdate;
  const enrolled = isEnrolled(enrollmentStatus);
  const lastSubmittedDate = userFeedbackSubmissionInfo === null || userFeedbackSubmissionInfo === void 0 ? void 0 : userFeedbackSubmissionInfo.latestSubmissionTimeStamp;
  const btnUseSecondary = isTrellis ? 'secondary' : 'tertiary-light';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!enrolled && rolloutState === 'PUBLIC_BETA' && /*#__PURE__*/_jsx(JoinEnrollmentButton, {
      enrollType: enrollType,
      enrollmentStatus: enrollmentStatus,
      gate: gate,
      productUpdateId: productUpdateId,
      isBetaClosed: isBetaClosed,
      rolloutId: rolloutId,
      size: "small",
      title: title,
      untranslatedTitle: untranslatedTitle
    }), !enrolled && rolloutState === 'PRIVATE_BETA' && /*#__PURE__*/_jsx(RequestToJoinEnrollmentButton, {
      enrollType: enrollType,
      enrollmentStatus: enrollmentStatus,
      gate: gate,
      productUpdateId: productUpdateId,
      isBetaClosed: isBetaClosed,
      rolloutId: rolloutId,
      size: "small",
      title: title,
      untranslatedTitle: untranslatedTitle
    }), enrolled && (rolloutState === 'PRIVATE_BETA' || rolloutState === 'PUBLIC_BETA') && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(FeedbackBtnClickTrackerContext.Provider, {
        value: {
          screen: TrackingScreen.PRODUCT_UPDATES,
          subscreen: categoryToSubscreenMap[category !== null && category !== void 0 ? category : 'all'],
          origin: 'table',
          rolloutState: rolloutState === 'PRIVATE_BETA' || rolloutState === 'PUBLIC_BETA' ? rolloutState : null,
          untranslatedPUTitle: untranslatedTitle
        },
        children: /*#__PURE__*/_jsx(MeetingScheduleLinkClickTrackerContext.Provider, {
          value: {
            screen: TrackingScreen.PRODUCT_UPDATES,
            subscreen: categoryToSubscreenMap[category !== null && category !== void 0 ? category : 'all'],
            origin: 'table'
          },
          children: /*#__PURE__*/_jsx(FeedbackButton, {
            use: btnUseSecondary,
            size: "small",
            rolloutId: rolloutId,
            productUpdateId: productUpdateId,
            productUpdateTitle: title,
            lastSubmittedDate: lastSubmittedDate
          })
        })
      })
    })]
  });
};
export default ProductUpdatesBetaButton;